import React from 'react'
import Hubnav from '../Hubnav'

const RemoveDeliveryBoy = () => {
  return (
    <>
    <Hubnav/>
    <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Remove Delivery Boy</h1>
          </div>
        </div>
      </section>
      <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 h-100 w-100 p-5 mx-auto">
            {/* {coupons
            ? coupons.map((data) => (
                
                <div className="col singleCard card target py-5" id={data.couponCode}>
                <div className="col card-body text-center">
                    <h4>{data.couponCode}</h4>
                    <h6>Discount: {data.discount}</h6>
                    <button className='btn btn-success rmv' onClick={()=>remove(data.couponCode)}>Remove Coupon</button>
                    </div>
                </div>
                

            )):""} */}
             </div>
    </>
  )
}

export default RemoveDeliveryBoy